module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/flag-1cc6a4af9a3857f626471b8180532ced.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/flag.svg
// module id = TwkI
// module chunks = 24